import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useStoreId } from '@thd-nucleus/experience-context';
import { number, params, shape, string, arrayOf, useDataModel } from '@thd-nucleus/data-sources';
import { useHelmet, RedirectTag } from '@thd-nucleus/thd-helmet';
import { RedirectContext } from './RedirectContext';
import { isInvalidPackageId, hasNoPackageData } from './rules/package-redirect-rules';
import { getPathWithMergedParams, handleErrors, ERROR_HANDLING_EXPERIENCE } from '../utils/redirector-utils';

const packagesHandler = ({ data, error, props }) => {

  const {
    packageId,
    bypass
  } = props;
  const invalid = isInvalidPackageId({ packageId });
  if (invalid) {
    return new RedirectTag(invalid, bypass);
  }

  const errors = handleErrors(error, ERROR_HANDLING_EXPERIENCE.PRODUCT);
  if (errors) {
    return new RedirectTag(errors, bypass);
  }

  const noData = hasNoPackageData({ data, packageId });
  if (noData) {
    return new RedirectTag(noData, bypass);
  }
  return null;
};

export const PackageRedirector = () => {

  const { pathWithQueryParams, packageId, bypass } = useContext(RedirectContext);
  const storeId = useStoreId();

  const props = {
    bypass,
    pathWithQueryParams,
    packageId
  };

  const opts = {
    variables: {
      packageId,
      storeId
    }
  };
  const { data, error } = useDataModel('packages', opts);

  useHelmet('packageRedirector', { data, error, props }, packagesHandler, [packageId]);
  //
  // const redirectRules = usePackageRedirectRules({ packageId });
  // const { shouldRedirect = false, redirectPath = '', httpCode = 200, isErrorStatus = false } = redirectRules;
  //
  // if (shouldRedirect || isErrorStatus) {
  //   const fullRedirectPath = queryParams ? `${getPathWithMergedParams(redirectPath, queryParams)}` : redirectPath;
  //   redirectState.redirect = shouldRedirect;
  //   redirectState.url = fullRedirectPath;
  //   redirectState.code = httpCode;
  //   redirectState.isErrorStatus = isErrorStatus;
  // }

  return null;
};

PackageRedirector.displayName = 'PackageRedirector';

PackageRedirector.propTypes = {};

PackageRedirector.defaultProps = {};

PackageRedirector.dataModel = {
  packages: params({ packageId: string().isRequired(), storeId: string() }).arrayOf(shape({
    products: arrayOf(shape({
      identifiers: shape({
        itemId: string(),
      })
    })),
    metadata: shape({
      packageId: string()
    })
  }))
};
